import React from 'react';
import { Field } from 'formik';
import styled from 'styled-components';

import { FormGroup } from 'components/bootstrap';
import PaginatedSelect from 'components/common/Select/PaginatedSelect';
import fetchDataLakeStreams from 'data-lake/preview/utils/fetchDataLakeStreams';

const Container = styled(FormGroup)`
  flex: 1;
  grid-area: streams;
`;

const placeholder = 'Select the stream you want to preview logs for';

const loadStreams = ({ page, perPage, query }) =>
  fetchDataLakeStreams({ page, perPage, query }).then(({ elements, pagination, total, query: queryRes }) => ({
    list: elements.map(({ last_known_stream_title, stream_id }) => ({
      label: last_known_stream_title,
      value: stream_id,
    })),
    pagination: { page: pagination.page, perPage: pagination.per_page, query: queryRes },
    total,
  }));

const StreamFilter = () => (
  <Field name="stream">
    {({ field: { name, value, onChange }, meta: { error } }) => (
      <Container data-testid="streams-filter" validationState={error ? 'error' : undefined} bsClass="no-bm">
        <PaginatedSelect
          placeholder={placeholder}
          displayKey="key"
          inputId="streams-filter"
          value={value}
          onLoadOptions={loadStreams}
          multi={false}
          onChange={(newStream: string) => {
            onChange({
              target: { value: newStream, name },
            });
          }}
        />
      </Container>
    )}
  </Field>
);

export default StreamFilter;
